import { useQuery } from "@tanstack/react-query";
import { useSearchParams } from "react-router-dom";
import axios from "../../../utils/axiosInceptor";
import { apiV1Endpoint } from "../endpoints";
import { ApiResponse } from "../types";
import { Organization } from "./types";

const getOrganization = async (orgId: string) => {
  const url = `${apiV1Endpoint}/organization/${orgId}`;
  const response = await axios.get<ApiResponse<Organization>>(url);
  return response.data.result;
};

export type UseGetOrganizationOptions = {
  isEnabled?: boolean;
};

export const useGetOrganization = (options: UseGetOrganizationOptions = {}) => {
  const { isEnabled = true } = options;
  const [searchParams] = useSearchParams();
  const orgId = searchParams.get("orgId") ?? "";

  const { data, isLoading, isSuccess } = useQuery({
    queryKey: ["organization", orgId],
    queryFn: () => getOrganization(orgId),
    enabled: Boolean(orgId) && isEnabled,
    staleTime: 5 * 60 * 1000, // cache for 5 minutes
    refetchOnWindowFocus: false,
  });

  return {
    organization: data,
    isLoadingOrganization: isLoading,
    isSuccessOrganization: isSuccess,
  };
};
